<template>
  <a-modal :centered="true" v-model="showModal" :footer="null" @cancel="hide" width="587px" :closable="false" class="mobile-modal-fullscreen">
    <div class="d-flex align-items-center">
      <font-awesome-icon size="2x" :icon="['fal', 'times']" class="show-in-mobile font-black mr-3 font20" @click="hide" />
      <h4 class="fw700 font24 gray700 mb-0">{{ action === "edit" ? "Edit" : "Add" }} Nutrition Info</h4>
      <div class="saveBtn ml-auto br6 p1224 font-white font14 fw700 cp show-in-mobile" :style="{ background: getPrimaryColor() }" @click="saveNut">
        <template v-if="posting"> <a-spin size="small" class="mr-2" /> Loading... </template>
        <template v-else> {{ action === "add" ? "Save" : "Update" }} </template>
      </div>
      <font-awesome-icon size="2x" :icon="['fal', 'times']" class="hide-in-mobile font-black ml-auto cp font20" @click="hide" />
    </div>

    <template v-if="action === 'add'">
      <div class="position-relative">
        <p class="fw700 font16 gray500 mt-5 mb-1">Type of Nutrition <span class="error500">*</span></p>
        <font-awesome-icon size="1x" :icon="['fal', 'search']" class="position-absolute dovedailySearch" />
        <a-select
          :allowClear="true"
          showSearch
          :size="'large'"
          v-model="nutritionData.nutrition"
          class="w-100 dovedailySelect"
          placeholder="Search Nutrition"
          :showArrow="false"
          :filterOption="false"
          @search="handleNutritionSearch"
          notFoundContent="No Data"
          :loading="loadingNut"
          @change="handleNutritionChange"
        >
          <a-select-option v-if="loadingNut" :key="0" :disabled="true">
            <span> <a-spin size="small" class="mr-2" /> Loading... </span>
          </a-select-option>
          <template v-else>
            <a-select-option v-for="nutrition in nutritions" :key="nutrition.id">
              {{ nutrition.display_name }}
            </a-select-option>
          </template>
        </a-select>
      </div>

      <a-radio-group v-model="nutritionData.prescribed" class="d-flex flex-column">
        <a-radio :value="true" class="mt-4 font14 gray900"> Prescibed to me </a-radio>
        <a-radio :value="false" class="mt-4 font14 gray900"> Done on my own </a-radio>
      </a-radio-group>

      <p class="fw700 font16 gray500 mt-4 mb-0">Nutrition Dates <span class="error500">*</span></p>
      <div class="mt-1 d-flex justify-content-between m-flex-column gap24">
        <!-- <a-date-picker
          :allowClear="true"
          class="flex-grow-1"
          :size="'large'"
          v-model="nutritionData.start_date"
          :placeholder="'From'"
          @change="handleStartDateChange"
          :disabled-date="tempValue => tempValue >= new Date()"
        >
          <template v-if="nutritionData.start_date" #suffixIcon>
            <font-awesome-icon
              :icon="['far', 'times']"
              class="gray400 cp show-in-mobile"
              @click="
                () => {
                  nutritionData.start_date = null
                }
              "
            />
          </template>
        </a-date-picker> -->
        <DatePicker
          v-model="nutritionData.start_date"
          :disabled-date="tempValue => tempValue >= new Date() || tempValue < new Date(authUser.user.dob)"
          placeholder="From"
          type="date"
          class="flex-grow-1 new-datepicker w-100"
          :append-to-body="false"
          :clearable="false"
        />
        <DatePicker
          v-model="nutritionData.end_date"
          :disabled-date="disabledDate"
          :disabled="nutritionData.currentlyUsing || !nutritionData.start_date"
          placeholder="To"
          type="date"
          class="flex-grow-1 new-datepicker w-100"
          :append-to-body="false"
          :clearable="false"
        />
        <!-- <a-date-picker
          v-model="nutritionData.end_date"
          :allowClear="true"
          class="flex-grow-1"
          :size="'large'"
          :disabled="nutritionData.currentlyUsing || !nutritionData.start_date"
          :disabled-date="disabledDate"
          placeholder="To"
          @change="handleEndDateChange"
        >
          <template v-if="nutritionData.end_date" #suffixIcon>
            <font-awesome-icon
              :icon="['far', 'times']"
              class="gray400 cp show-in-mobile"
              @click="
                () => {
                  nutritionData.end_date = null
                }
              "
            />
          </template>
        </a-date-picker> -->
      </div>
    </template>

    <div v-else class="gray500 font16 p-3 bg-gray50 rounded shadow mt-5">
      You are editing:
      <span class="fw700 font16 gray900 ml-3">{{ nutritionData.display_name }}</span>
    </div>

    <!-- <div class="d-flex align-items-center font14 gray900 mt-3">
      <input type="checkbox" class="mr-2 cp" v-model="nutritionData.currentlyUsing" />
      Currently Using
    </div>

    <div v-if="action === 'edit'" class="mt-3 d-flex align-items-center font14 gray900">
      <input type="checkbox" class="mr-2 cp" v-model="nutritionData.stopppedTaking" />
      I stopped taking
    </div> -->

    <div class="mt-3 d-flex align-items-center font14 gray900" v-if="action === 'add'">
      <input type="checkbox" class="mr-2 cp" v-model="nutritionData.currentlyUsing" />
      Currently Using
    </div>

    <template v-else>
      <div class="mt-3 d-flex align-items-center font14 gray900">
        <input type="radio" class="mr-2 cp" v-model="nutritionData.currentlyUsing" :value="true" />
        Currently Using
      </div>

      <div v-if="action === 'edit'" class="mt-3 d-flex align-items-center font14 gray900">
        <input type="radio" class="mr-2 cp" v-model="nutritionData.currentlyUsing" :value="false" />
        I stopped taking
      </div>
    </template>

    <template v-if="action === 'add' || nutritionData.currentlyUsing">
      <!-- <template v-if="!nutritionData.stopppedTaking"> -->
      <div class="mt-3">
        <label class="mb-1 font16 fw700 gray500 font16">Effectiveness</label>
        <a-slider class="dovemed-slider mt-0" :marks="effectMarks" :step="50" :tooltipVisible="false" v-model="nutritionData.effectiveness" :disabled="nutritionData.dontKnow" />
      </div>

      <div class="mt-3 pt-3 d-flex align-items-center font14 gray900">
        <input type="checkbox" class="cp mr-2" v-model="nutritionData.dontKnow" />
        I don’t know
      </div>

      <div class="position-relative mt-3">
        <p class="mb-1 fw700 font16 gray500">Addons</p>
        <font-awesome-icon size="1x" :icon="['fal', 'search']" class="position-absolute dovedailySearch" />
        <a-select
          mode="multiple"
          :value="nutritionData.addons.length ? nutritionData.addons : undefined"
          :show-search="true"
          :size="'large'"
          placeholder="Add tags to refine your diet"
          allowClear
          :filterOption="false"
          class="w-100 dovedailySelect sideEffectSelect"
          notFoundContent="No Data"
          @search="searchAddons"
          @change="handleAddons"
          :getPopupContainer="trigger => trigger.parentNode"
          :disabled="action === 'add' ? !nutritionData.nutrition : false"
        >
          <!-- :disabled="!nutritionData.nutrition" -->
          <a-select-option v-for="addon in addonsList" :key="addon" :value="addon">
            {{ addon }}
          </a-select-option>
        </a-select>
      </div>

      <div v-if="nutritionData.addons.length" class="addonContainer mt-3">
        <div v-for="addon in nutritionData.addons" :key="addon" class="addon">
          {{ addon }}
          <font-awesome-icon :icon="['fas', 'trash']" class="error300 cp" @click="deleteAddon(addon)" />
        </div>
      </div>
    </template>

    <template v-else>
      <p class="font16 fw700 gray500 mt-4">Why did you stop?</p>
      <a-select :allowClear="true" showSearch :size="'large'" v-model="reasonToStop" class="w-100 reasonOptions" placeholder="Reason to Stop" :showArrow="false" :filterOption="false">
        <a-select-option v-for="reason in stopReasons" :key="reason.id" :value="reason.name">
          {{ reason.name }}
        </a-select-option>
      </a-select>
      <a-input class="mt-4 reasonText" v-if="reasonToStop === 'Other'" placeholder="Write your reason" :maxlength="160" v-model="otherReason" />
    </template>

    <div class="saveBtn ml-auto br6 p1224 font-white font14 fw700 mt-5 cp" :style="{ background: getPrimaryColor() }" @click="saveNut">
      <template v-if="posting"> <a-spin size="small" class="mr-2" /> Loading... </template>
      <template v-else> {{ action === "add" ? "Save" : "Update" }} </template>
    </div>
  </a-modal>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import DatePicker from "vue2-datepicker"

const AppRepository = RepositoryFactory.get("app")
const UserRepository = RepositoryFactory.get("user")

export default {
  name: "NutritionModal",
  components: { DatePicker },
  data() {
    return {
      posting: false,
      showModal: false,
      action: "",
      nutritionData: {
        nutrition: undefined,
        stopppedTaking: false,
        prescribed: true,
        start_date: null,
        end_date: null,
        currentlyUsing: false,
        dontKnow: false,
        effectiveness: 50,
        addons: [],
      },
      addonsList: [],
      nutritions: [],
      effectMarks: {
        0: {
          style: { left: 0, marginLeft: 0, fontSize: "10px", top: "8px", color: "#33415F", transform: "none" },
          label: "NOT EFFECTIVE",
        },
        50: {
          style: { color: "#33415F", fontSize: "10px", top: "8px" },
          label: "SOMEWHAT EFFECTIVE",
        },
        100: {
          style: { right: 0, left: "unset", color: "#33415F", marginRight: 0, fontSize: "10px", top: "8px", transform: "none" },
          label: "VERY EFFECTIVE",
        },
      },
      stopReasons: [
        { name: "Doctor Recommended me to stop", id: 0 },
        { name: "Not seeing desired results", id: 1 },
        { name: "I could not afford it", id: 2 },
        { name: "My insurance did not cover", id: 3 },
        { name: "Other", id: "other" },
      ],
      reasonToStop: "",
      otherReason: undefined,
      loadingNut: false,
      editingId: 0,
      other_condition_id: 0,
      reFetch: null,
    }
  },
  methods: {
    async searchAddons(key) {
      AppRepository.getAddons(key, this.currentCircle.id)
        .then(res => {
          if (res.data.message === "Found") {
            this.addonsList = res.data.data.circle_symptoms.map(addon => addon.display_name)
          } else {
            this.addonsList = []
          }
        })
        .catch(e => {})
    },
    deleteAddon(v) {
      this.nutritionData.addons = this.nutritionData.addons.filter(a => a !== v)
    },
    disabledDate(current) {
      return current > new Date() || current < this.moment(this.nutritionData.start_date)
    },
    handleStartDateChange(date, dateString) {
      this.nutritionData.start_date = dateString
      this.nutritionData.end_date = null
    },
    handleEndDateChange(date, dateString) {
      this.nutritionData.end_date = dateString
    },
    show(action, oldVal, other_condition_id = 0, reFetch = null) {
      this.reFetch = reFetch
      this.other_condition_id = other_condition_id
      this.action = action
      this.showModal = true
      this.searchAddons("")
      if (action === "add") {
        this.handleNutritionSearch()
      } else {
        this.nutritionData = {
          ...this.nutritionData,
          ...oldVal,
          effectiveness: oldVal.effectiveness || 50,
          display_name: oldVal.treatment[0].display_name,
          nutrition: oldVal.treatment[0],
        }
        this.editingId = oldVal.id
        if (!oldVal.treatment_duration[0][1]) {
          this.nutritionData.currentlyUsing = true
        }
        if (!oldVal.effectiveness) {
          this.nutritionData.dontKnow = true
        }
        if (oldVal.add_ons && oldVal.add_ons.length) {
          this.nutritionData.addons = oldVal.add_ons.map(addon => addon.display_name)
        }
      }
    },
    hide() {
      this.showModal = false
      this.nutritionData = {
        nutrition: "",
        prescribed: true,
        start_date: null,
        end_date: null,
        currentlyUsing: false,
        dontKnow: false,
        effectiveness: 50,
        addons: [],
      }
    },
    handleNutritionSearch(val = "") {
      this.loadingNut = true
      AppRepository.searchTreatments(val, this.currentCircle.id, "nutrition", 1)
        .then(res => {
          this.loadingNut = false
          this.nutritions = res.data.data.circle_treatments
        })
        .catch(err => {
          this.loadingNut = false
        })
    },
    handleNutritionChange(val) {
      this.nutritionData.nutrition = val
    },
    handleAddons(value) {
      this.nutritionData.addons = value
    },
    async saveNut() {
      if ((!this.nutritionData.nutrition || !this.nutritionData.start_date || (!this.nutritionData.end_date && !this.nutritionData.currentlyUsing)) && this.action !== "edit") {
        this.$notification.error({ message: "Error", description: "Please fill the necessary fields" })
        return
      }
      if (this.other_condition_id) {
        try {
          this.posting = true
          if (this.action === "edit") {
            const editPayload = { effectiveness: this.nutritionData.dontKnow ? null : this.nutritionData.effectiveness, add_ons: this.nutritionData.addons.map(addon => ({ display_name: addon })) }
            if (!this.nutritionData.currentlyUsing) {
              editPayload["stopped_treatment"] = true
              editPayload["reason_to_stop_treatment"] = this.reasonToStop
              editPayload["other_reason_to_stop_treatment"] = this.otherReason || ""
              editPayload["treatment_duration"] = [[this.nutritionData.treatment_duration[0][0], this.moment().format("YYYY-MM-DD")]]
            } else if (this.nutritionData.currentlyUsing) {
              editPayload["treatment_duration"] = [[this.nutritionData.treatment_duration[0][0], null]]
            }
            await UserRepository.editOtherConditionNutrition(this.editingId, editPayload)
            this.$notification.success({ message: "Success", description: "Nutrition Edited" })
          } else {
            const res = await UserRepository.saveOtherConditionNutrition({
              user_role: this.authUser.user.role,
              othercondition_id: this.other_condition_id,
              nutrition: this.nutritionData.nutrition,
              activity_freq: null,
              user_circle: this.currentCircle.id,
              user: this.authUser.user.id,
              treatment_duration: [
                [
                  this.moment(this.nutritionData.start_date).format("YYYY-MM-DD"),
                  !this.nutritionData.currentlyUsing && this.nutritionData.end_date ? this.moment(this.nutritionData.end_date).format("YYYY-MM-DD") : null,
                ],
              ],
              effectiveness: this.nutritionData.dontKnow ? null : this.nutritionData.effectiveness,
              add_ons: this.nutritionData.addons.map(addon => ({ display_name: addon })),
            })
            this.$notification.success({ message: "Success", description: res.data.message === "treatment updated" ? "Updated the Nutrition" : "Nutrition Added" })
          }
          this.posting = false
          this.hide()
          this.reFetch()
          return
        } catch (e) {
          console.log(e)
          this.$notification.error({ message: "Error", description: "Nutrition was not updated" })
          this.posting = false
          return
        }
      }
      if (this.posting) {
        return
      }
      this.posting = true
      if (this.action === "edit") {
        const editPayload = { effectiveness: this.nutritionData.dontKnow ? null : this.nutritionData.effectiveness, add_ons: this.nutritionData.addons.map(addon => ({ display_name: addon })) }
        if (!this.nutritionData.currentlyUsing) {
          editPayload["stopped_treatment"] = true
          editPayload["reason_to_stop_treatment"] = this.reasonToStop
          editPayload["other_reason_to_stop_treatment"] = this.otherReason || ""
          editPayload["treatment_duration"] = [[this.nutritionData.treatment_duration[0][0], this.moment().format("YYYY-MM-DD")]]
        } else if (this.nutritionData.currentlyUsing) {
          editPayload["treatment_duration"] = [[this.nutritionData.treatment_duration[0][0], null]]
        }
        UserRepository.editTreatments(this.editingId, editPayload)
          .then(res => {
            this.$notification.success({ message: "Success", description: "Your nutrition has been edited" })
            // UserRepository.updateDovedaily(this.currentCircle.id, { updated_at: new Date() })
            //   .then(res => {
            //     this.$router.go()
            //   })
            //   .catch(e => {
            //     this.$router.go()
            //   })
            this.$router.go()
          })
          .catch(e => {
            this.posting = false
            this.$notification.error({ message: "Error", description: "Nutrition could not be edited" })
          })
      } else {
        const payload = {
          treatment: this.nutritionData.nutrition,
          treatment_type: "Nutrition",
          activity_freq: null,
          user_circle: this.currentCircle.id,
          user: this.authUser.user.id,
          treatment_duration: [
            [
              this.moment(this.nutritionData.start_date).format("YYYY-MM-DD"),
              !this.nutritionData.currentlyUsing && this.nutritionData.end_date ? this.moment(this.nutritionData.end_date).format("YYYY-MM-DD") : null,
            ],
          ],
          effectiveness: this.nutritionData.dontKnow ? null : this.nutritionData.effectiveness,
          add_ons: this.nutritionData.addons.map(addon => ({ display_name: addon })),
        }
        UserRepository.addTreatments(payload)
          .then(res => {
            // this.$notification.success({ message: "Success", description: "Nutrition Added" })
            this.$notification.success({ message: "Success", description: res.data.message === "treatment updated" ? "Updated the Nutrition" : "Nutrition Added" })
            // UserRepository.updateDovedaily(this.currentCircle.id, { updated_at: new Date() })
            //   .then(res => {
            //     this.$router.go()
            //   })
            //   .catch(e => {
            //     this.$router.go()
            //   })
            this.$router.go()
          })
          .catch(e => {
            this.$notification.error({ message: "Error", description: "Nutrition could not be added" })
            this.posting = false
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.saveBtn {
  width: fit-content;
}
.shadow {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}
.addonContainer {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.addon {
  display: flex;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  padding: 16px;
  gap: 24px;
  font-weight: 700;
  font-size: 16px;
  color: #0f1734;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/dovedaily/Nutrition.vue